import type React from "react";
import {
    CLEAR_DIALOG,
    type DialogActionTypes,
    type DialogType,
    HIDE_DIALOG,
    SHOW_DIALOG,
} from "../Actions/DialogActions";
import { type DialogButtonType } from "../Layout/Dialog/Dialog";

export interface DialogState {
    visible: boolean;
    title: string;
    content: React.ReactNode;
    buttons: Array<DialogButtonType>;
    type: DialogType;
    wide: boolean;
}

const DEFAULT_STATE: DialogState = {
    visible: false,
    type   : "normal",
    title  : "",
    content: null,
    buttons: [],
    wide   : false,
};

/**
 * Developer Layout Reducer function
 */
export default function DialogReducer(
    state: DialogState | undefined,
    action: DialogActionTypes
): DialogState {
    if(typeof state === "undefined") {
        return DEFAULT_STATE;
    }

    switch(action.type) {
        case SHOW_DIALOG:
            return {
                ...state,
                visible: true,
                title  : action.title,
                content: action.content,
                buttons: action.buttons,
                type   : action.dialogType,
                wide   : action.wide,
            };
        case HIDE_DIALOG:
            return {
                ...state,
                visible: false,
            };
        case CLEAR_DIALOG:
            return DEFAULT_STATE;
        default:
            return state;
    }
}
